import { Pipe, PipeTransform } from '@angular/core';

import { empresaSituacoesCadastrais } from '../empresa-situacao-cadastral';

@Pipe({
    name: 'empresaSituacaoCadastral'
})
export class EmpresaSituacaoCadastralPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = empresaSituacoesCadastrais.findIndex(situacaoCadastral => situacaoCadastral.id === value);
        if (index > -1) {
            return empresaSituacoesCadastrais[index].nome;
        }

        return '';
    }
}
